import { Dispatch, SetStateAction } from "react";
import {
  SpaceBetween,
  Box,
  TableProps,
  Table as CSDTable,
} from "@cloudscape-design/components-themed";
import { COMMON_LABELS } from "../default-constants";
import { LABELS } from "./constants";
import { setItems } from "../UI/modal/search-modal-slice";
import type { RootState } from "../../app/store";
import { useAppSelector, useAppDispatch } from "../../app/hook";
import { useGetCompanyNamesQuery } from "../../features/api";
import { CompanyNamesSearchResponse } from "../../features/api-interfaces";
import { USER_TYPE } from "../../configs/constants";

interface ITable {
  selectedItems: CompanyNamesSearchResponse[];
  setSelectedItems: Dispatch<SetStateAction<CompanyNamesSearchResponse[]>>;
  isSkipSearch: boolean;
}

/**
 * 事業者名検索結果
 */
const Table = (props: ITable) => {
  const { selectedItems, setSelectedItems, isSkipSearch } = props;
  const dispatch = useAppDispatch();

  // 検索条件取得
  const searchCondition = useAppSelector(
    (state: RootState) => state.companyNameSearchCondition
  );

  // データの取得
  const { data, isFetching } = useGetCompanyNamesQuery(searchCondition, {
    skip: isSkipSearch,
  });

  // ラベル
  let columnLabel: string;
  switch (searchCondition.companyType) {
    case USER_TYPE.MERCHANT_GEN:
    case USER_TYPE.MERCHANT_INC:
      columnLabel = LABELS.COMPANY_NAME;
      break;
    case USER_TYPE.HD:
      columnLabel = LABELS.COMPANY_NAME_HD;
      break;
    case USER_TYPE.GW:
      columnLabel = LABELS.COMPANY_NAME_GW;
      break;
    default:
      columnLabel = "";
  }

  // カラム設定
  const colummDefinitions = [
    {
      header: columnLabel,
      cell: (e: CompanyNamesSearchResponse) => e.companyName,
      width: 120,
    },
  ];

  // 選択変更関数
  const onSelectionChange = ({
    detail,
  }: {
    detail: TableProps.SelectionChangeDetail<CompanyNamesSearchResponse>;
  }) => {
    setSelectedItems([...detail.selectedItems]);
    dispatch(
      setItems({
        items: detail.selectedItems,
      })
    );
  };

  if (!data) return null;

  return (
    <CSDTable
      onSelectionChange={onSelectionChange}
      selectedItems={selectedItems}
      columnDefinitions={colummDefinitions}
      loadingText={COMMON_LABELS.CSD.LOADING_TEXT}
      items={data}
      resizableColumns
      stickyHeader
      loading={isFetching}
      selectionType="single"
      header={
        <SpaceBetween size="xs">
          <SpaceBetween direction="horizontal" size="l"></SpaceBetween>
        </SpaceBetween>
      }
      empty={
        <Box textAlign="center" color="inherit">
          {COMMON_LABELS.CSD.NO_DATA}
        </Box>
      }
    />
  );
};

export default Table;
